import { connect } from "react-redux";
import { authenticate, cancelWizard } from "./actions";
import Layout from "../../components/Layout";
import { Publisher } from "../Wizard";

type ReducerProps = { router: { location: { pathname: string } }, wizard: { publisher: Publisher } };
const mapStateToProps = ({
  router: {
    location: { pathname },
  },
  wizard: {
    publisher
  },
}: ReducerProps) => ({
  pathname,
  publisher,
});

export default connect(mapStateToProps, { authenticate, cancelWizard })(Layout);
